import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { CTA } from '../../interfaces/CTA.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import Heading, { HeadingTypes } from '../Heading/Heading';
import Image from '../Image/Image';
import { StoryblokRichtext } from 'storyblok-rich-text-react-renderer';
import RichText, { screenWidth } from '../RichText/RichText';
import SbImage from '../SbImage/SbImage';

interface CTABarLargeProps extends Blok {
  image: StoryblokAsset;
  heading: string;
  body?: StoryblokRichtext;
  cta: Blok[];
}

interface CTABarLargeBlokProps {
  blok: CTABarLargeProps;
}

const CTABarLarge: React.FC<CTABarLargeBlokProps> = ({ blok }) => {
  const { image, heading, body, cta } = blok;

  return (
    <div {...storyblokEditable(blok)}>
      <Container startingBreakpoint="lg">
        <Grid gapY="gap-y-0">
          <Col span={{ lg: 5 }}>
            <div className="pt-16 pb-12 flex items-center justify-center px-6 lg:min-h-[376px] lg:py-20 xl:pl-0 2xl:min-h-[533px]">
              <div className="w-full space-y-8 flex flex-col items-center justify-center lg:items-start">
                <div className="space-y-5 text-center lg:text-left">
                  {heading && (
                    <Heading text={heading} headingType={HeadingTypes.h2} />
                  )}
                  {body && (
                    <div className="px-6 lg:px-0">
                      <RichText
                        content={body}
                        centerResponsively={screenWidth.LG}
                      />
                    </div>
                  )}
                </div>
                {cta &&
                  cta.map((cta_item: Blok) => (
                    <StoryblokComponent blok={cta_item} key={cta_item._uid} />
                  ))}
              </div>
            </div>
          </Col>
          <Col span={{ lg: 6 }} start={{ lg: 7 }}>
            <div className="w-full h-full">
              <SbImage
                asset={image}
                options={{ objectFit: 'cover', sizes: { base: 1600, md: 768 } }}
              />
            </div>
          </Col>
        </Grid>
      </Container>
    </div>
  );
};

export default memo(withBlokWrapper(CTABarLarge, Theme.DARK));
